// Табы в модальном окне при создании договора
import { useState } from 'react';
import { Tabs } from 'antd';
import ClientContractTab from 'pages/Outstaffing/clientContractTab';
import ClientTemplates from 'pages/Outstaffing/clientTemplates';
import OutstaffingClientsForms from 'pages/Outstaffing/outstaffingClientsForms';
import UploadDocuments from 'pages/Outstaffing/upload-documents';

const ContractTabs = ({ isEdit, selectedCity }) => {
	const [activeKey, setActiveKey] = useState('1');

	const handleTabChange = (key) => {
		setActiveKey(key);
	};

	const items = [
		{
			key: '1',
			label: 'Договор',
			children: <ClientContractTab isEdit={isEdit} selectedCity={selectedCity} />,
		},
		{
			key: '2',
			label: 'Клиент',
			children: <OutstaffingClientsForms isEdit={isEdit} selectedCity={selectedCity} />,
		},
		{
			key: '3',
			label: 'Шаблоны',
			children: <ClientTemplates />,
		},
		{
			key: '4',
			label: 'Сканы документов',
			children: <UploadDocuments />,
		},
	];

	return (
		<Tabs
			activeKey={activeKey}
			items={items}
			centered={true}
			size='large'
			tabBarGutter={142}
			onChange={(key) => handleTabChange(key)}
		/>
	);
};

export default ContractTabs;